import React from 'react'
import './EditPropertyNotes.scss'
import PropTypes from 'prop-types'
import { Dialog, DialogContent, DialogActions, Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import TextareaAutosize from '@material-ui/core/TextareaAutosize'
import { QuillEditor } from '../../common'

const styles = {
  muiDialogActions: {
    padding: '0px !important'
  }
}
export class EditPropertyNotes extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      propNotes: props.propertyNotes
    }
  }

  componentDidUpdate = prevProps => {
    if (prevProps.propertyNotes !== this.props.propertyNotes) {
      this.setState({ propNotes: this.props.propertyNotes.trim() })
    }
  }

  render() {
    const {
      isDialogOpen,
      notesLimit,
      propertyNotes,
      editPropertyNotes,
      closeEditPopup,
      classes,
      propertyLabel
    } = this.props
    const { propNotes } = this.state
    const notesLength = propNotes && propNotes.length

    const textCounter = e => {
      const { value } = e.target
      this.setState({ propNotes: value })
    }

    const saveNotes = notes => {
      editPropertyNotes(notes.trim())
      closeEditPopup()
    }

    const handleCancel = () => {
      this.setState({ propNotes: propertyNotes })
      closeEditPopup()
    }

    const onEditorChange = value => {
      this.setState({ propNotes: value })
    }

    return (
      <div className="empty_notes" data-testid="edit-property-notes">
        <Dialog
          open={isDialogOpen}
          maxWidth={'sm'}
          data-testid="notes-comps-dialog"
        >
          <DialogContent className={propertyLabel === 'notes' && 'no-padding'}>
            {(propertyLabel === 'sourcenotes' || propertyLabel?.includes('salesnotes')) ? (
              <TextareaAutosize
                aria-label="maximum height"
                className="content notes_text"
                value={propNotes}
                onInput={textCounter}
                data-testid="editable_notes"
              />
              ) : (
              <QuillEditor editorHtml = {propNotes} onEditorChange = {onEditorChange} placeholder = {'Write something...'} />
            )}
            <hr className="divider-color" />
          </DialogContent>
          <DialogActions className={classes.muiDialogActions}>
            <div className="action-area">
              <div className="char-count" id="editnotestest">
                {notesLength || 0}/{notesLimit}
                {propNotes && propNotes.length > notesLimit && (
                  <small className="helper-text">
                    Notes length exceeds the template limit
                  </small>
                )}
              </div>
              <div className="btn-box">
                <Button
                  className="btn cancel"
                  data-testid="editnotes-cancel"
                  id="editnotes-cancel"
                  color="primary"
                  variant="contained"
                  size="large"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
                <Button
                  className="btn done"
                  data-testid="editnotes-done"
                  id="editnotes-done"
                  color="primary"
                  variant="contained"
                  size="large"
                  onClick={() => saveNotes(propNotes)}
                >
                  <span className="tick">
                    <img src="/images/btn_done.svg" />
                  </span>{' '}
                  Done
                </Button>
              </div>
            </div>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

EditPropertyNotes.propTypes = {
  propertyNotes: PropTypes.string,
  notesLimit: PropTypes.number,
  closeEditPopup: PropTypes.func,
  classes: PropTypes.object,
  isDialogOpen: PropTypes.bool,
  editPropertyNotes: PropTypes.func,
  propertyLabel: PropTypes.string
}

export default withStyles(styles)(EditPropertyNotes)
